module.exports = __webpack_public_path__ + "c745848aeca75f6d231851faaa6a3646.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/US-CA.svg
// module id = w81o
// module chunks = 0